import React from "react";

import MediumButton from "../MediumButton";
import DirectSearchModal from "../search/DirectSearchModal";
import { useTransition } from "react-transition-state";
import type { Masters } from "~/types";
import { useSearch } from "~/context/SearchContext";

type Props = {
  masters: Masters;
};

const ZeroFound: React.FC<Props> = ({ masters }) => {
  const [visible, setVisible] = React.useState(false);
  const [number, setNumber] = React.useState(0);

  const {
    conditions: selectedConditions,
    addCondition: handleAddCondition,
    removeCondition: handleSubCondition,
    resetConditions: handleResetConditions,
    setConditions: setSelectedConditions,
    setAppliedConditions,
    initialState,
  } = useSearch();

  // モーダル開閉アニメーション用
  const [{ status }, transitionToggle] = useTransition({
    timeout: 1,
    preEnter: true,
  });

  const stateToggle = () => {
    setVisible(!visible);
    setNumber(0);
    transitionToggle(true);
  };

  // この条件で検索するボタンクリック時の挙動
  const handleVisibleToFalse = () => {
    transitionToggle(false);
    setTimeout(() => {
      setVisible(false);
    }, 1000);
  };

  // 閉じる（x）ボタンクリック時の挙動
  const handleVisibleToFalseForClose = () => {
    transitionToggle(false);
    setTimeout(() => {
      setVisible(false);
    }, 1000);
  };

  return (
    <>
      <div className="py-6 text-center">
        <h4 className="mb-2 text-lg font-bold md:text-2xl">
          この条件に該当する求人はありません。
        </h4>
        <p className="mb-6 text-sm md:text-base">
          他の条件で検索してみましょう。
        </p>
        <div className="[&_button]:w-[280px]">
          <MediumButton
            handler={stateToggle}
            text="検索条件を変更する"
            color="white"
          ></MediumButton>
        </div>
      </div>
      <div className={`group ${status}`}>
        {visible && (
          <DirectSearchModal
            setVisible={setVisible}
            activeTab={number}
            masters={masters}
            handleAddCondition={handleAddCondition}
            handleSubCondition={handleSubCondition}
            handleResetConditions={handleResetConditions}
            handleVisibleToFalse={handleVisibleToFalse}
            handleVisibleToFalseForClose={handleVisibleToFalseForClose}
            selectedConditions={selectedConditions}
            setSelectedConditions={setSelectedConditions}
            setAppliedConditions={setAppliedConditions}
            initialState={initialState}
          />
        )}
      </div>
    </>
  );
};

export default ZeroFound;
